
import React from 'react';
import { Redirect, Route, BrowserRouter, Switch } from 'react-router-dom';

import { PATHS } from '../common/constants';

import ForgotPassword from '../pages/ForgotPassword';

import ResetPassword from '../pages/ResetPassword';

import { SignIn } from '../pages/SignIn';

import SignOut from '../components/SignOut';
import activate from '../pages/Activate';

const AuthRoutes = () => {
    return (
        <BrowserRouter>
        <Switch>
          <Route
            path={PATHS.AUTH_SIGN_IN}
            component={SignIn}
          />
          <Route
            path={PATHS.AUTH_FORGOT_PASSWORD}
            component={ForgotPassword}
          />
          <Route
            path={PATHS.AUTH_RESET_PASSWORD}
            component={ResetPassword}
          />
          <Route
            path={PATHS.AUTH_ACTIVATE}
            component={activate}
          />
          <Route
            path={PATHS.AUTH_SIGN_OUT}
            component={SignOut}
          />
          <Route path="/">
            <Redirect to={PATHS.AUTH_SIGN_IN} />
          </Route>
        </Switch>
      </BrowserRouter>
    )
}

export default AuthRoutes;